import React from 'react';
import { Box } from '@mui/material';


/**
 * # SessionBox
 * @param {*} children  
 */
const SessionBoxContent = ({ children, noPaddingTop }) => {
      return (
            <Box id="SessionBoxContent" sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  width: '100%',
                  padding: noPaddingTop ? '0px 30px 30px 30px' : '30px 30px 30px 30px',
                  backgroundColor: 'background',
                  gap: 4
            }} >
                  {children}
            </Box>
      );
};

export default SessionBoxContent;
